import { Paper, Stack, Typography } from '@mui/material';
import type { Customer, CustomerRelationType } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';

import { UpdateCustomerChildren } from '../../../UpdateCustomerSettingsPage/update-customer-settings-components/UpdateCustomerChildren/UpdateCustomerChildren';
import type { CreateCustomerMode } from '../../create-customer-page-types/CreateCustomerModeType';
import { CustomerAliasesSection } from './create-customer-advanced-components/CustomerAliasesSection.tsx';
import { ConditionalWrapper } from '../../../../../components/utility/ConditionalWrapper.tsx';

type CreateCustomerAdvancedProps = CreateCustomerMode & {
  customer?: Customer;
  customerChildren?: Customer[];
  childrenRelations?: { childId: string; relationType: CustomerRelationType }[];
};
export const CreateCustomerAdvanced: React.FC<CreateCustomerAdvancedProps> = ({
  mode = 'create',
  customer,
  customerChildren,
  childrenRelations,
}) => {


  return (
    <ConditionalWrapper
      condition={mode === 'update'}
      wrapper={(children) => (
        <Paper
          elevation={1}
          sx={{
            marginBottom: 3,
            padding: '24px 32px',
            borderRadius: '10px',
            boxShadow: '0px 10px 24px rgba(0,0,0,0.03)',
            border: '1px solid rgba(13,27,39,0.1)',
            minHeight: '150px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            overflow: 'auto',
            minWidth: '880px',
          }}
        >
          {children}
        </Paper>
      )}
    >
      <Stack spacing={3}>
        <Typography variant="h5" sx={{ fontWeight: 500, paddingTop: 1 }}>
          Advanced
        </Typography>

        <CustomerAliasesSection mode={mode} />

        {mode === 'update' && isNotNullOrUndefined(customer) && (
          <UpdateCustomerChildren
            customerId={customer.id}
            customerName={customer.name}
            customerChildren={customerChildren}
            childrenRelations={childrenRelations}
          />
        )}
      </Stack>
    </ConditionalWrapper>
  );
};
